<!-- [ngClass]="{'disabled' : isGlobal && selectedBookings.length < 1} -->
<div class="popover-content">
  <app-select *ngIf="vendors && elementType"
  [type]="'dropdownAndSearch'"
  [getCustomOptionValue]="vendors ? getVendorValue : null"
  [getCustomOptionLabel]="vendors ? getVendorLabel : null"
  [formControl]="vendorFormControl"
  (changeCallback)="onVendorSelected($event)"
  [options]="vendors || vendorSelectConfigObj['VendorAssignment'].values"
  [blockInitialChangeCallback]="isGlobal || !vendorFormControl.value ? false : true"
  [label]="label">
</app-select>
</div>

